import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3556156157/src/medh-web/src/components/layout/main/Home1.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3556156157/src/medh-web/src/components/shared/wrappers/PageWrapper.tsx");
